import { OrderSearchService } from '../../../services/order-search.service';

/**
 * @param {string} scanValue
 * @returns {string}
 */
export const parseScanForFulfillmentPlanId = (scanValue) => {
  const trimmedString = OrderSearchService.getOrderId(scanValue);
  const parsedFulfillmentPlanId = parseInt(trimmedString, 16);
  return `${parsedFulfillmentPlanId}`;
};
